import moment from 'moment'

export function parseDataParam (data) {
  if (!(data && data instanceof Date)) {
    return undefined
  }
  return moment(data).format('YYYY-MM-DD')
}
